var today = new Date();
var date = today.getFullYear()+' / '+(today.getMonth()+1)+' / '+today.getDate();
export const product = {
    discount : 30,
    info : [
        {
            description : 'Logo Design',
            price : 440,
            qty : 2,
        },
        {
            description : 'Web Site Design',
            price : 120,
            qty : 4,
        },
        {
            description : 'Logo Design',
            price : 300,
            qty : 1,
        },
    ] 
}

export const dataInvoice = [
    {
        label : 'Invoice',
        value : '#565254',
    },
    {
        label : 'Date',
        value : date,
    },
    {
        label : 'Due Date',
        value : '#30 / 02 /2022',
    }, 
]
export const location = [
    '#Main Road',
    '#Building Name',
    '#Country',
]
export const paymentInfo=[
    {
        label : 'Account',
        value : '000 0000 000',
    },
    {
        label : 'A/C NAME',
        value : '000 0000 000',
    },
    {
        label : 'BANK DETAILS',
        value : 'Your Account',
    }, 
]

export const connections = {
    connection : {
        number : '000 000 000',
        email : 'www.facebook.com',
        address : 'your street addres here',
    }
}

export const companyInfo = {
    info :{
        managerName : '#Manager Name',
        customerName : '#Customer Name',
        productName : '#Product Name',
    }
}
